// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2hsvl","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__EGQIq"};